<script lang="ts" setup>
  import { Component, computed, defineComponent, h, ref, useSlots } from 'vue'
  import {themingCssClass} from "vue/applications/frontend/mixins/theming-mixin"

  const Vnodes = (props: any, context: any) =>{
    return h(props.vnodes, context.attrs, context.slots);
  }
  Vnodes.props = ['vnodes']

  const slots = useSlots();

  const props = defineProps({
    tabHeaders: {
      type: Object,
      default: () => {
        return {};
      },
    },
  });

  const currentSelection = ref<any>(null);

  const selectedSlot = computed(() => {
    if (currentSelection.value) {
      return slots[currentSelection.value];
    } else {
      return slots[Object.keys(slots)[0]];
    }
  });

  const slotHeader = (slotName: any, tabNames: any) => {
    if (Object.keys(tabNames).indexOf(slotName) >= 0) {
      return tabNames[slotName];
    } else {
      return slotName;
    }
  };

  const select = (tabName: any) => {
    currentSelection.value = tabName;
  };
  const slotCssClasses = (slot: any, name: any, index: number) => {
    const result = [];

    if (
      currentSelection.value === name ||
      (!currentSelection.value && index === 0)
    ) {
      result.push(themingCssClass("inverted"));
    } else {
      result.push(themingCssClass("normal"));
      result.push(themingCssClass("light_background"));
    }

    return result;
  };
</script>

<template>
  <div class="components__tabbed-content">
    <div class="tabs">
      <div
        v-for="(slot, name, index) in slots"
        v-bind:key="name"
        class="tab"
        v-bind:class="slotCssClasses(slot, name, index)"
        v-on:click="select(name)"
      >
        {{ slotHeader(name, tabHeaders) }}
      </div>
    </div>
    <div class="content">
      <Vnodes v-bind:vnodes="selectedSlot" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~stylesheets/frontend/variables/colors";

.components__tabbed-content {
  .tabs {
    display: flex;

    .tab {
      padding: 8px 20px;
      margin-right: 16px;
      font-size: 16px;
      border-radius: 2px;
      cursor: pointer;
    }

    margin-bottom: 28px;
  }
}
</style>
